module.exports = __webpack_public_path__ + "img/icon_interface_over.92ac4fcc.svg";